// Same rules as backend referentials.draw_questions: the snapshot is frozen at Take 5 creation.
export function drawQuestions(questions, vary, rand = Math.random) {
  if (!vary) return questions.map((q) => ({ id: q.id, variant: "simple", text: q.text, safe_answer: q.simple_safe_answer || "oui" }));
  const variants = questions.map((q) => (q.negative_text && rand() < 0.5 ? "negative" : "positive"));
  const able = questions.map((q, i) => (q.negative_text ? i : -1)).filter((i) => i >= 0);
  if (questions.length >= 2 && able.length && new Set(variants).size === 1) {
    const pool = variants[0] === "positive" ? able : questions.map((_, i) => i);
    variants[pool[Math.floor(rand() * pool.length)]] = variants[0] === "positive" ? "negative" : "positive";
  }
  return questions.map((q, i) => {
    const base = q.simple_safe_answer || "oui";
    const neg = variants[i] === "negative";
    return { id: q.id, variant: variants[i], text: neg ? q.negative_text : q.text, safe_answer: neg ? (base === "oui" ? "non" : "oui") : base };
  });
}

export const safeAnswer = (q) => q.safe_answer || "oui";
export const isConform = (q, a) => a === safeAnswer(q);
